export default function extractExpireTime(expire?: string): number | undefined {
  if (!expire) return undefined;

  const expireString = expire.split('.')[0];
  const expireTime = expireString ? new Date(expireString).getTime() : undefined;
  if (expireTime && isNaN(expireTime)) return undefined;

  const currentTime = Date.now();
  const timeUntilExpire = expireTime ? Math.max(0, expireTime - currentTime) : undefined;

  return timeUntilExpire;
}
